// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaseTemplates_root__Nj\\+-E {
    width: 100%;
    color: var(--color-font-10);
    overflow: scroll;
    height: calc(100vh - 133px);
    overflow-y: scroll;
  }
  
  .CaseTemplates_template_list_container__BrRo0 {
    position: fixed;
    left: 210px;
    top: 91px;
    width: 290px;
    background-color: var(--color-bg-caselist);
    overflow: scroll;
    padding: 10px;
    overflow-x: hidden;
    height: calc(100vh - 140px);
    z-index: 100;
  }
  
  /* add flow row  */
  .CaseTemplates_email_flow_input__EIwqn {
    background-color: var(--color-bg-caselist-item);
    outline: none;
    border: none;
    color: var(--color-font-10);
    font-weight: bold;
    font-size: 16px;

    margin: 0 auto;
    width: fit-content;
    text-align: center;
    align-self: center;
  }
  
  .CaseTemplates_email_row_root__RMY8s {
    margin-top: 10px;
    display: flex;
    color: var(--color-theme-10);
    height: 45px;
    cursor: pointer;
    align-items: center;
    padding: 5px;
  
    background-color: var(--color-bg-caselist-item);
    border: 2px solid var(--color-bg-caselist-item);
  }
  
  .CaseTemplates_email_row_root__RMY8s:hover {
    background-color: var(--color-bg-caselist-item-hover);
    border: 2px solid var(--color-bg-caselist-item-hover);
  }
  
  .CaseTemplates_account_tree_icon__MXTzs {
    margin: 0px 10px;
  }
  /* template details */
  .CaseTemplates_template_container__NZHF6 {
    overflow: hidden;
    margin-left: 310px;
    background-color: var(--color-bg-content);
  }
  
  .CaseTemplates_template_no_data__9z6b6 {
    text-align: center;
    margin-top: 300px;
    text-transform: uppercase;
    font-size: 24px;
    color: var(--color-theme-silver);
  }
  
  .CaseTemplates_add_template_container__BDzV5{
    display: flex;
    justify-content: center;
  }`, "",{"version":3,"sources":["webpack://./src/@_components/CaseTemplates/CaseTemplates.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,SAAS;IACT,YAAY;IACZ,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAGlB,2BAA2B;IAC3B,YAAY;EACd;;EAEA,kBAAkB;EAClB;IACE,+CAA+C;IAC/C,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;;IAEf,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,YAAY;;IAEZ,+CAA+C;IAC/C,+CAA+C;EACjD;;EAEA;IACE,qDAAqD;IACrD,qDAAqD;EACvD;;EAEA;IACE,gBAAgB;EAClB;EACA,qBAAqB;EACrB;IACE,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB","sourcesContent":[".root {\n    width: 100%;\n    color: var(--color-font-10);\n    overflow: scroll;\n    height: calc(100vh - 133px);\n    overflow-y: scroll;\n  }\n  \n  .template_list_container {\n    position: fixed;\n    left: 210px;\n    top: 91px;\n    width: 290px;\n    background-color: var(--color-bg-caselist);\n    overflow: scroll;\n    padding: 10px;\n    overflow-x: hidden;\n    height: -webkit-calc(100vh - 105px);\n    height: -moz-calc(100vh - 105px);\n    height: calc(100vh - 140px);\n    z-index: 100;\n  }\n  \n  /* add flow row  */\n  .email_flow_input {\n    background-color: var(--color-bg-caselist-item);\n    outline: none;\n    border: none;\n    color: var(--color-font-10);\n    font-weight: bold;\n    font-size: 16px;\n\n    margin: 0 auto;\n    width: fit-content;\n    text-align: center;\n    align-self: center;\n  }\n  \n  .email_row_root {\n    margin-top: 10px;\n    display: flex;\n    color: var(--color-theme-10);\n    height: 45px;\n    cursor: pointer;\n    align-items: center;\n    padding: 5px;\n  \n    background-color: var(--color-bg-caselist-item);\n    border: 2px solid var(--color-bg-caselist-item);\n  }\n  \n  .email_row_root:hover {\n    background-color: var(--color-bg-caselist-item-hover);\n    border: 2px solid var(--color-bg-caselist-item-hover);\n  }\n  \n  .account_tree_icon {\n    margin: 0px 10px;\n  }\n  /* template details */\n  .template_container {\n    overflow: hidden;\n    margin-left: 310px;\n    background-color: var(--color-bg-content);\n  }\n  \n  .template_no_data {\n    text-align: center;\n    margin-top: 300px;\n    text-transform: uppercase;\n    font-size: 24px;\n    color: var(--color-theme-silver);\n  }\n  \n  .add_template_container{\n    display: flex;\n    justify-content: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CaseTemplates_root__Nj+-E`,
	"template_list_container": `CaseTemplates_template_list_container__BrRo0`,
	"email_flow_input": `CaseTemplates_email_flow_input__EIwqn`,
	"email_row_root": `CaseTemplates_email_row_root__RMY8s`,
	"account_tree_icon": `CaseTemplates_account_tree_icon__MXTzs`,
	"template_container": `CaseTemplates_template_container__NZHF6`,
	"template_no_data": `CaseTemplates_template_no_data__9z6b6`,
	"add_template_container": `CaseTemplates_add_template_container__BDzV5`
};
export default ___CSS_LOADER_EXPORT___;
